import Vue from "vue";
import Router from "vue-router";

import Login from "@/pages/login.vue";
import Creatives from "@/pages/creatives.vue";
import Gallery from "@/pages/gallery.vue";
import Report from "@/pages/report.vue";
import Audiences from "@/pages/audiences.vue";
import Preview from "@/pages/preview.vue";
import Iframe from "@/pages/previews/iframe.vue";
import NotFound from "@/pages/notFound.vue";
import Assets from "@/pages/assets.vue";
import Advertisers from "@/pages/advertisers.vue";
import CreativeReport from "@/pages/creativeReport.vue";
import Template from "@/pages/template.vue";
import LoginComponent from "@/components/pages/login/login.vue";
import ResetPasswordComponent from "@/components/pages/login/resetPassword.vue";
import UserManagement from "@/pages/userManagement.vue";
import Verification from "@/components/pages/login/verification.vue";
import SignUp from "@/components/pages/login/signUp.vue";
import Pricing from "@/pages/pricing.vue";
// backstage component
import BackstageLogin from "@/backstage/pages/login.vue";
import BackstageCreatorManagement from "@/backstage/pages/creatorManagement.vue";
import BackstageLoginComponent from "@/backstage/components/login/login.vue";
import BackStageUserManagement from "@/backstage/pages/userManagement.vue";

Vue.use(Router);

const frontstage = [
  {
    path: "/login",
    name: "login",
    component: Login,
    children: [
      {
        name: "login",
        path: "",
        component: LoginComponent,
      },
      {
        name: "reset_password",
        path: "reset_password",
        component: ResetPasswordComponent,
      },
      {
        name: "verification",
        path: "verification",
        component: Verification,
      },
      {
        name: "sign_up",
        path: "sign_up",
        component: SignUp,
      },
    ],
  },
  {
    path: "/",
    redirect: { name: "gallery" },
  },
  {
    path: "/gallery",
    name: "gallery",
    component: Gallery,
    meta: { requiresAuth: true },
  },
  {
    path: "/creatives",
    name: "creatives",
    component: Creatives,
    meta: { requiresAuth: true },
  },
  {
    path: "/folder/:folderId",
    name: "creatives",
    component: Creatives,
    meta: { requiresAuth: true },
  },
  {
    path: "/advertisers",
    name: "advertisers",
    component: Advertisers,
    meta: { requiresAuth: true },
  },
  {
    path: "/advertiser/:advertiserId",
    name: "advertisers",
    component: Advertisers,
    meta: { requiresAuth: true },
  },
  {
    path: "/assets",
    name: "assets",
    component: Assets,
    meta: { requiresAuth: true },
  },
  {
    path: "/preview/iframe/",
    name: "iframe",
    component: Iframe,
  },
  {
    path: "/preview/:creativeId",
    name: "preview",
    component: Preview,
  },
  {
    path: "/template/:creativeId",
    name: "template",
    component: Template,
  },
  {
    path: "/report",
    name: "report",
    component: Report,
    meta: { requiresAuth: true },
  },
  {
    path: "/report/creative",
    name: "creative_report",
    component: CreativeReport,
    meta: { requiresAuth: true },
  },
  {
    path: "/audiences",
    name: "audiences",
    component: Audiences,
    meta: { requiresAuth: true },
  },
  {
    path: "/userManagement",
    name: "userManagement",
    component: UserManagement,
    meta: { requiresAuth: true },
  },
  { path: "*", name: "404", component: NotFound },
  // pricing is not deicded
  // {
  //   path: "/pricing",
  //   name: "pricing",
  //   component: Pricing,
  // },
];
const backstage = [
  { path: "*", name: "404", component: NotFound },
  {
    path: "/login",
    name: "login",
    component: BackstageLogin,
    children: [
      {
        name: "login",
        path: "",
        component: BackstageLoginComponent,
      },
    ],
  },
  {
    path: "/",
    redirect: { name: "login" },
  },
  {
    path: "/backstage_creator_management",
    name: "backstage_creator_management",
    component: BackstageCreatorManagement,
  },
  {
    path: "/backstage_creator_management/:creator_id",
    name: "backstage_user_management",
    component: BackStageUserManagement,
  },
  // pricing is not deicded
  // {
  //   path: "/pricing",
  //   name: "pricing",
  //   component: Pricing,
  // },
];

const isBackstage =
  window.location.origin === `${config.dashboard_backstage_domain}`
    ? true
    : false;
let routes;
if (isBackstage) {
  routes = backstage;
} else {
  routes = frontstage;
}

var router = new Router({
  mode: "history",
  routes,
});

router.beforeEach(async (to, from, next) => {
  const auth = Vue.prototype.$cookies.get("auth");
  const valid = auth ? moment().isBefore(auth.expires) : false;

  // login check
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (!valid) {
      next({
        path: "/login",
      });
    }
  }

  if (to.path === "/login") {
    if (valid) {
      next({
        path: "/",
      });
    }
  }

  // user server
  if (to.path === "/callback") {
    if (!valid) await store.dispatch("user/login", to.query);
    next({
      path: "/",
    });
  }

  if (to.path === "/logout") {
    store.dispatch("user/logout");
    next({
      path: "/login",
    });
  }

  next();
});

// back to top after changing page
router.afterEach((to, from, next) => {
  window.scrollTo(0, 0);
});

export default router;
